import React from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CloseIcon from '@mui/icons-material/Close';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Chip, IconButton, Typography } from '@mui/material';
import { ChatAiAssistState } from '../../hooks/admin/useChatAiAssist';
import { Palette } from 'Palette';

interface ChatAiAssistPanelHeaderProps {
  assist: ChatAiAssistState;
}

export const ChatAiAssistPanelHeader: React.FC<ChatAiAssistPanelHeaderProps> = ({ assist }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      px: 1.5,
      py: 1.25,
      flexShrink: 0,
      borderBottom: assist.mode === 'open' ? '1px solid #e3e8ef' : 'none',
      backgroundColor: '#fff',
      cursor: assist.mode === 'minimized' ? 'pointer' : 'default',
    }}
    onClick={assist.mode === 'minimized' ? () => assist.setMode('open') : undefined}
  >
    <AutoAwesomeIcon fontSize="small" sx={{ color: Palette.default.buttonBg }} />
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography variant="subtitle2" fontWeight={700}>
        Vera assist
        <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
          admin only · saved in cloud
        </Typography>
      </Typography>
      {assist.mode === 'minimized' && assist.targetPreview && (
        <Typography variant="caption" color="text.secondary" noWrap>
          Re: &ldquo;{assist.targetPreview}&rdquo;
        </Typography>
      )}
    </Box>
    {assist.latestResult?.cached && assist.mode === 'open' && (
      <Chip size="small" label="Saved" variant="outlined" sx={{ height: 22 }} />
    )}
    <IconButton
      size="small"
      aria-label={assist.mode === 'open' ? 'Minimize Vera assist' : 'Expand Vera assist'}
      onClick={(event) => {
        event.stopPropagation();
        assist.setMode((current) => (current === 'open' ? 'minimized' : 'open'));
      }}
    >
      {assist.mode === 'open' ? (
        <ExpandMoreIcon fontSize="small" />
      ) : (
        <ExpandLessIcon fontSize="small" />
      )}
    </IconButton>
    <IconButton
      size="small"
      aria-label="Close Vera assist"
      onClick={(event) => {
        event.stopPropagation();
        assist.setMode('closed');
      }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  </Box>
);
